export default "__VITE_ASSET__C8kRHQbS__"